import { useState } from "react";
import { Link } from "react-router-dom";

import logo from "../assets/24logo.png"

export default function Header(props) {

    const [bannerShown, setBannerShown] = useState(true);

    return (
        <div className="header">
            <div className="header-container">
                <Link to="/">
                    <img src={logo} />
                </Link>
            </div>
        </div>
    );
}